//@ts-nocheck
import React, { useState } from "react";
import { IRootStore } from "../stores";
import { EditSubjectWrapper } from "./SubjectEditView";
import {
  CustomPopupDisplay,
  ForceDrawerDisplay,
} from "./forms/SharedComponents";
import {
  Box,
  Button,
  Icon as CIcon,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  useDisclosure,
} from "@chakra-ui/react";
import { AddSubjectDrawer } from "./Subject";
import { SubjectCreationTimer } from "./SubjectPrompt";
import { BiRocket } from "react-icons/bi";
import { scrollToId } from "../utils/functions";
import { observer } from "mobx-react-lite";
import { CLIENT_PAGES } from "../stores/client-types";

const MessageBox: React.FC<{
  title?: string;
  icon?: any;
  children?: React.ReactNode;
}> = ({
  title = "",
  icon = <CIcon as={BiRocket} color="orange.400" fontSize="5xl" />,
  children,
}) => (
  <Box
    my={5}
    px={[5, 6]}
    py={[4, 5]}
    rounded="lg"
    borderWidth="2xs"
    borderColor="orange.100"
    bg="orange.50"
    shadow="sm"
    overflow="hidden"
  >
    <SubjectCreationTimer title="" icon={icon}>
      <Box>{children}</Box>
    </SubjectCreationTimer>
  </Box>
);

const SubjectComponent: React.FC<{
  store: IRootStore;
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onCloseModal: () => void;
}> = observer(({ store, isOpen = true, isLoading, onClose, onCloseModal }) => {
  const {
    isOpen: isSelectOpen,
    onClose: onSelectClose,
    onOpen: onSelectOpen,
  } = useDisclosure();
  const [displayError, setDisplayError] = useState(false);

  function handleButtonClick() {
    if (store.populateRequiredSubjectsErrors.length === 0) {
      setDisplayError(false);
      onClose();
    } else {
      setDisplayError(true);
      scrollToId("requiredSubjectError");
    }
  }

  return (
    <ForceDrawerDisplay
      path={"/edit-job-subjects"}
      isOpen={isOpen}
      isDesktopDrawer={true}
      onClose={onCloseModal}
      closeOnOverlayClick={false}
    >
      {displayError ? (
        <Box id="requiredSubjectError">
          <MessageBox>
            <Text fontWeight="bold" color="red">
              Please take action on the following
            </Text>
            <UnorderedList color="red">
              {store.populateRequiredSubjectsErrors.map((error, index) => (
                <ListItem key={index}>{error}</ListItem>
              ))}
            </UnorderedList>
          </MessageBox>
        </Box>
      ) : null}
      <EditSubjectWrapper
        store={store.subject}
        onSubjectAction={(a: any) => {
          if (a.action === "add") {
            onSelectOpen();
          }
          if (a.action === "edit") {
            store.subject.saveSubject(a.subject.id);
            store.subject.setCurrentSubjectId(a.subject.id);
          }
          if (a.action === "take_test") {
            store.subject.setCurrentSubjectId(a.subject.id);
            // onTakeTest(subject.name);
          }
          console.log(a);
        }}
        generic={true}
        educationAndWorkHistoryData={{
          education: store.educationWorkHistory.formValues.educations,
          workHistory: store.educationWorkHistory.formValues.workHistories,
        }}
        getPriceSuggestion={store.getPriceSuggestion}
      ></EditSubjectWrapper>
      <AddSubjectDrawer
        isOpen={isSelectOpen}
        store={store.subject}
        onClose={() => {
          onSelectClose();
        }}
      />
      {/* <Stack>
        <Button
          isLoading={isLoading}
          loadingText="Submitting"
          size="lg"
          mt={3}
          colorScheme="blue"
          onClick={handleButtonClick}
        >
          Submit Entry
        </Button>
      </Stack> */}
    </ForceDrawerDisplay>
  );
});

export const SubjectWithGeneric: React.FC<{
  store: IRootStore;
  buttonText?: string;
  onSubmit: (callback?: any) => void;
  addRequiredSubjects?: () => any;
}> = observer(
  ({
    store,
    addRequiredSubjects,
    onSubmit,
    buttonText = "Populate Subjects",
  }) => {
    const [loading, setLoading] = React.useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    console.log(store.subject.subjectsRequiredForJob);
    function notComplete(result) {
      store.initializeClientTutorData(CLIENT_PAGES.SUBJECTS, result);
      setLoading(false);
      onOpen();
    }
    async function onBeginStep(e) {
      e.preventDefault();
      setLoading(true);
      try {
        await onSubmit(notComplete);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    async function onCloseSubmit() {
      setLoading(true);
      try {
        await onSubmit(() => {
          onClose();
          setLoading(false);
        });
      } catch (error) {
        setLoading(false);
      }
    }
    return (
      <Stack>
        <Button
          onClick={onBeginStep}
          colorScheme="blue"
          size={"lg"}
          isLoading={loading}
          loadingText={"Sending Entry"}
        >
          {buttonText}
        </Button>
        {store.subject.canApplyFoJob ? (
          <SubjectComponent
            store={store}
            isOpen={isOpen}
            onCloseModal={onClose}
            isLoading={loading}
            onClose={onCloseSubmit}
          />
        ) : (
          <MessageBox title="Can not apply for job" />
        )}
      </Stack>
    );
  },
);

export default SubjectWithGeneric;
